import EventEmitter from "./utils/EventEmitter";

export default class MultipleViewsCustomTabs extends EventEmitter {
    constructor(element) {
        super();

        this.el = element

        this.tabsButtons = Array.from(element.querySelectorAll('.tab-button'))
        this.tabsContent = Array.from(element.querySelectorAll('.tab-content'))

        // get support block in the page
        this.supportBlock = document.querySelector('.paragraph--type--soutien')
        if (this.supportBlock) {
            this.supportBlockClone = this.supportBlock.cloneNode(true)
            this.supportBlock.remove()
        }

        if (this.tabsButtons.length > 0) {
            this.events()
            this.tabsButtons[0].click()
        }
    }

    events() {
        this.tabsButtons.forEach((item) => {
            item.addEventListener('click', () => {
                if (item.classList.contains('active'))
                    return

                if (this.activeTabContent) {
                    this.oldActiveTabContent = this.activeTabContent
                    this.oldActiveTabContent.classList.add('leaving')
                }

                this.tabsButtons.forEach((tabButton) => {
                    tabButton.classList.remove('active')
                })
                this.tabsContent.forEach((tabContent) => {
                    tabContent.classList.remove('active')
                })

                item.classList.add('active')

                this.activeTabContent = this.el.querySelector(`.tab-content[data-tab="${item.dataset.tabTitle}"]`)

                if (!this.activeTabContent.classList.contains('loaded')) {
                    this.fetchView(this.activeTabContent.dataset.viewName, this.activeTabContent.dataset.viewDisplayId, this.activeTabContent.dataset.viewArgs)
                } else {
                    this.insertSupportBlock()
                    setTimeout(() => {
                        this.oldActiveTabContent.classList.remove('leaving')
                        this.activeTabContent.classList.add('active')
                    }, 400)
                }
            })
        })
    }

    fetchView(viewName, viewDisplayId, viewArgs) {
        const formData = new FormData();
        formData.append('view_name', viewName);
        formData.append('view_display_id', viewDisplayId);
        formData.append('view_args', viewArgs);

        const fetchOptions = {
            method: 'POST',
            body: formData,
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest', // Pour indiquer une requête AJAX
            },
        };

        const ajaxUrl = Drupal.url('views/ajax');

        fetch(ajaxUrl, fetchOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                if (data[3] !== undefined) {
                    const viewHtml = data[3].data;
                    this.activeTabContent.innerHTML = '';
                    this.activeTabContent.innerHTML = viewHtml;


                    if (this.oldActiveTabContent) {
                        this.oldActiveTabContent.classList.remove('leaving')
                    }
                    this.activeTabContent.classList.add('active')
                    this.activeTabContent.classList.add('loaded')

                    Drupal.settings = data[0].settings;
                    Drupal.settings.dialog = {
                        "autoResize": true,
                        "maxHeight": "95%",
                        "autoOpen": true,
                        "dialogClass": "",
                        "buttonClass": "button",
                        "buttonPrimaryClass": "button--primary"
                    }
                    drupalSettings.views = data[0].settings.views;
                    Drupal.attachBehaviors(this.activeTabContent, Drupal.settings);

                    if (this.supportBlock) {
                        this.insertSupportBlock()
                    }

                    this.trigger('viewLoaded')
                }
            })
            .catch((error) => {
                console.error('Fetch error:', error);
            });
    }

    insertSupportBlock() {
        // insert the clone of the support block in the active tab
        // select view-content div in activeTabContent
        const viewContent = this.activeTabContent.querySelector('.view-content')
        // That div contains children divs, we want to insert the support block at the middle of the children divs
        const viewContentChildren = Array.from(viewContent.children)
        const middleIndex = Math.floor(viewContentChildren.length / 2)
        const middleChild = viewContentChildren[middleIndex]
        viewContent.insertBefore(this.supportBlockClone, middleChild)
    }
}
